import { TrueBase, css, html } from "../TrueBase/TrueBase";

export const buttonStyles = css`
  :host {
    display: var(--button-display, inline-flex);
  }

  :host([isButton]) ::slotted(a),
  button {
    display: var(--button-display, inline-flex);
    justify-content: var(--button-justify-content, center);
    align-items: var(--button-align-items, center);
    text-align: var(--button-text-align, center);
    vertical-align: var(--button-vertical-align, middle);
    touch-action: var(--button-touch-action, manipulation);
    white-space: var(--button-white-space, nowrap);
    transition: var(--transition, all 0.3s ease);
    position: var(--button-position, relative);
    padding: var(--button-padding, 1em 2em);
    margin: var(--button-margin, 0);
    border: var(--button-border, 1px solid black);
    border-radius: var(--button-border-radius, 5px);
    background: var(--button-background, black);
    background-image: var(--button-background-image, none);
    color: var(--button-color, white);
    cursor: var(--button-cursor, pointer);
    font-size: var(--button-font-size, 1em);
    font-weight: var(--button-font-weight, normal);
    font-family: var(--button-font-family, inherit);
    text-transform: var(--button-text-transform, none);
    box-shadow: var(--button-box-shadow, none);
  }

  :host([isButton]:hover) ::slotted(a),
  :host([isButton]:focus) ::slotted(a),
  :host([isButton]:active) ::slotted(a),
  :host(:hover) button,
  :host(:focus) button,
  :host(:active) button {
    border: var(--button-hover-border, 1px solid black);
    color: var(--button-hover-color, black);
    background: var(--button-hover-background, white);
  }

  :host([isButton]:focus) ::slotted(a),
  :host([isButton]:active) ::slotted(a),
  button:focus,
  button:active {
    outline: var(--button-outline, none);
  }

  :host([buttonIconPosition="right"]) button,
  :host([buttonIconPosition="right"]) ::slotted(a) {
    flex-direction: row-reverse;
  }

  :host([isLoading]) {
    pointer-events: none;
    cursor: wait;
  }

  :host([isloading]) button::before,
  :host([isloading]) ::slotted(a)::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    margin: var(--button-loading-margin, 0 1rem 0 0);
    width: var(--button-loading-width, 1rem);
    height: var(--button-loading-height, 1rem);
    border: var(--button-loading-border, 2px solid #cecece);
    border-top-color: var(--button-loading-border-top-color, white);
    animation: rotating 1s infinite;
  }
`;
export class TrueButton extends TrueBase {
  static get properties() {
    return {
      hasIcon: {
        type: Boolean,
      },
      buttonIconPosition: {
        type: String,
      },
      isLoading: {
        type: Boolean,
      },
      isSubmit: {
        type: Boolean,
      },
      ariaLabel: {
        type: String,
      },
    };
  }

  constructor() {
    super();
  }

  firstUpdated() {
    this.addEventListener("keydown", (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        this.click();
      }
    });
    this.setAttribute("role", "button");
    //this.setAttribute("aria-label", this.ariaLabel || this.innerText);
  }

  get form() {
    const form = this.closest("form");
    return form || "";
  }

  get inputSubmit() {
    let inputSubmitSlot;
    let input;
    if (this.shadowRoot) {
      inputSubmitSlot = this.shadowRoot.querySelectorAll("slot");
      inputSubmitSlot.forEach((s) => {
        if (s.name === "submit") {
          const nodes = s.assignedNodes();
          input = nodes.find(
            (n) => n.nodeName === "INPUT" || n.nodeName === "BUTTON"
          );
        }
      });
    }
    return input;
  }

  onButtonClick() {
    const buttonEvent = new CustomEvent("true-submit-clicked");
    this.dispatchEvent(buttonEvent);
    if (this.isSubmit) {
      if (this.form && this.inputSubmit) {
        this.inputSubmit.click();
      }
    }
  }

  render() {
    return !this.isSubmit
      ? html`
          <button type="button" aria-label="${this.ariaLabel}">
            ${this.hasIcon ? html` <slot name="buttonIcon"></slot> ` : ""}
            <slot></slot>
          </button>
        `
      : html` <button
            @click="${this.onButtonClick}"
            aria-label="${this.ariaLabel}"
          >
            ${this.hasIcon ? html` <slot name="buttonIcon"></slot> ` : ""}
            <slot></slot>
            test
          </button>
          <slot name="submit"></slot>`;
  }

  static get styles() {
    return [super.styles, buttonStyles];
  }
}

window.customElements.get("true-button") ||
  window.customElements.define("true-button", TrueButton);
